const SUPPORT_COUNTRY = {
  BR: "Br",
  MX: "Mx",
  CO: "Mx",
  CL: "Mx",
  PE: "Mx",
  PA: "Mx",
  AU: 'Au'
}
const OLD_REGISTER_URL = {
  BR: "https://page.99taxis.mobi/common/register",
  MX: "https://page.didiglobal.com/global/driver/apps/register"
}
const LOGIN_CONFIG = {
  "COMMON": {
    appid: 30004,
    role: 2,
    city_id: 0,
    lang: "es-MX"
  },
  'MX': {
    country_calling_code: '+52',
    canonical_country_code: 'MX',
  },
  'CO': {
    country_calling_code: '+57',
    canonical_country_code: 'CO',
  },
  'CL': {
    country_calling_code: '+56',
    canonical_country_code: 'CL',
  },
  'PE': {
    country_calling_code: '+51',
    canonical_country_code: 'PE',
  },
  'AU': {
    country_calling_code: '+61',
    country_id: 36,
    lang: 'en-US',
    canonical_country_code: 'AU',
  }
};
const SOURCE = {
  web: '',
  fleet: 'com.didiglobal.fleet',
  global: 'com.didiglobal.driver',
  globalIos: 'com.didi.global.driver',
  br_99: 'com.app99.driver',
  minibus_new: 'com.didiglobal.bus',
  minibus_old: 'com.didiglobal.driver.bus',
};
let up = new URLSearchParams(location.search);
const ends = {
  inApp: !!Fusion.pickImage,
  isFleet: up.get("bundle_id") === SOURCE.fleet,
  isIOS: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent),
  isAndroid: /(Android)/i.test(navigator.userAgent),
  isPC: up.get("from") === "official_site",
  isPassengerTerminal: !!((/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
    (up.get("datatype") == 101)) || (/(Android)/i.test(navigator.userAgent) &&
    (up.get("datatype") == 1)))
}
const IOS_MAP_URL = "https://maps.apple.com/"
const ANDROID_MAP_URL = "https://maps.google.com/maps"

//todo notes 其他三国电话
const SERVICE_PHONE = {
  MX: "018007258888",
  CO: "",
  CL: "",
  PE: ""
}
export {
  SUPPORT_COUNTRY,
  ends,
  SOURCE,
  OLD_REGISTER_URL,
  LOGIN_CONFIG,
  IOS_MAP_URL,
  ANDROID_MAP_URL,
  SERVICE_PHONE
}
